module.exports = __webpack_public_path__ + "img/education3.b0a04391.png";